import { createContext, useContext, type ReactNode } from "react";

export interface ConnectorMergeTagScope {
  connectorId?: string;
  selectedEventId?: string;
}

const ConnectorMergeTagScopeContext = createContext<ConnectorMergeTagScope>({});

export function ConnectorMergeTagScopeProvider({
  scope,
  children,
}: {
  scope: ConnectorMergeTagScope;
  children: ReactNode;
}) {
  return (
    <ConnectorMergeTagScopeContext.Provider value={scope}>
      {children}
    </ConnectorMergeTagScopeContext.Provider>
  );
}

// Provider and consumer belong together so every merge-tag surface shares one scope.
// eslint-disable-next-line react-refresh/only-export-components
export function useConnectorMergeTagScope(): ConnectorMergeTagScope {
  return useContext(ConnectorMergeTagScopeContext);
}
